/* Date Helper */

const DateHelper = {

  convertCreateDate: (date) => {
    if (typeof date !== 'string') date = `${date}`;
    const y = date.substring(0, 4);
    const m = date.substring(4, 6);
    const d = date.substring(6, 8);
    const h = date.substring(8, 10);
    const min = date.substring(10, 12);
    return `${m}/${d}/${y} ${h}:${min}`;
  },

  convertCampaignDate: (date) => {
    if (typeof date !== 'string') date = `${date}`;
    const y = date.substring(0, 4);
    const m = date.substring(5, 7);
    const d = date.substring(8, 10);
    return `${m}/${d}/${y}`;
  },

  isValidCampaignDate: (date) => {
    if (typeof date !== 'string') date = `${date}`;
    let valid;
    if (date !== '' && date !== ' ' && date !== '00') {
      valid = true;
    } else {
      valid = false;
    }
    return valid;
  },

}

export default DateHelper;
